{
	"adminPanel": "Admin panel",
	"staffRole": "Staff role",
	"items": "items",
	"dashboard": "Dashboard",
	"usersPage": "Users",
	"listPlayers": "List players",
	"listGroupPlayers": "Players in the group",
	"listGroupShifts": "Hall shifts history",
	"periodStart": "Period start",
	"periodEnd": "Period end",
	"selectPeriod": "Select period",
	"cashierId": "Cashier ID",
	"openedDate": "Shift begin",
	"shift": "Shift",
	"shifts": "Shifts",
	"closedDate": "Shift end",
	"listLogoutPlayers": "Logout players",
	"listStaffs": "List staffs",
	"player": "Player",
	"info": "Info",
	"wallets": "Wallets",
	"payments": "Payments",
	"transactions": "Transactions",
	"gamingSessions": "Gaming sessions",
	"accounts": "Accounts",
	"withdrawalRequests": "Withdrawal requests",
	"depositRequests": "Deposit requests",
	"bonuses": "Bonuses",
	"files": "Files",
	"requisites": "Requisites",
	"staff": "Staff",
	"gamesPage": "Games",
	"listGames": "Games",
	"listCategories": "Categories",
	"listTags": "Tags",
	"listProvidersIntegrations": "Integrations with providers",
	"listMaintenances": "Maintenance list",
	"game": "Game",
	"metrics": "Metrics",
	"category": "Category",
	"translations": "Translations",
	"gameInCategory": "Games in the category",
	"editGamesList": "Edit games list",
	"tag": "Tag",
	"integration": "Integration",
	"integrationArtifact": "Integration artifact",
	"appearedGames": "Appeared games",
	"disappearedGames": "Исчезнувшие игры",
	"changedGames": "Changed games",
	"maintenance": "Maintenance",
	"gamesMaintenance": "Maintenance games",
	"providersMaintenance": "Maintenance providers",
	"paymentSystems": "Payment systems",
	"paymentSystem": "Payment system",
	"paymentSystemsList": "Payment systems list",
	"paymentsMethodsWithdrawalsList": "Methods withdrawals",
	"paymentsMethodsDepositsList": "Methods deposits",
	"deposits": "Deposits",
	"withdrawals": "Withdrawals",
	"invoice": "Invoice",
	"promoCodes": "Promo codes",
	"promoCode": "Promo code",
	"promoCodesList": "Promo codes list",
	"partnersPrograms": "Partners programs",
	"partnersProgram": "Partners program",
	"partnersPostbacks": "Partners postbacks",
	"partnersPostback": "Partners postback",
	"cms": "CMS",
	"widgets": "Widgets",
	"promoSlidesList": "Promo slides",
	"promoSlide": "Promo slide",
	"newsList": "News list",
	"news": "News",
	"textsList": "Texts list",
	"text": "Text",
	"chat": "Chat",
	"messagesList": "Messages list",
	"blackList": "Black list",
	"levelsList": "Levels list",
	"presetsList": "Presets list",
	"preset": "Preset",
	"configCashback": "Config cashback",
	"configReferrals": "Config referrals",
	"configDeposits": "Config deposits",
	"configDeposit": "Config deposit",
	"bonusesList": "Bonuses list",
	"missions": "Missions",
	"mission": "Mission",
	"addBonuses": "Add bonuses",
	"addGames": "Add games",
	"createCategory": "Create category",
	"createTag": "Create tag",
	"createPromoSlide": "Create promo slide",
	"createNews": "Create news",
	"createText": "Create text",
	"createPreset": "Create preset",
	"createConfigDeposits": "Create config deposits",
	"lastChecked": "Last checked",
	"memory": "Memory",
	"dependencies": "Dependencies",
	"name": "Name",
	"reason": "Reason",
	"status": "Status",
	"actions": "Actions",
	"attach": "Attach",
	"attached": "Attached",
	"detach": "Detach",
	"macAddress": "MAC Address",
	"additionDate": "Addition date",
	"modalTitle.pinCode": "PIN-code",
	"amount": "Amount",
	"amountInForeignCurrency": "Foreign amount",
	"totalAll": "Total",
	"totalDeposits": "Total deposits",
	"totalWithdrawals": "Total withdrawals",
	"cashbox": "Cashbox",
	"providers": "Providers",
	"id": "ID",
	"playerId": "Player ID",
	"gameId": "Game ID",
	"uuid": "Provider id",
	"integrationId": "Integration id",
	"phone": "Phone",
	"email": "Email",
	"fullName": "Full name",
	"surname": "Surname",
	"nickname": "Nickname",
	"birthday": "Birthday",
	"sex": "Sex",
	"banned": "Banned",
	"autoWithdrawalApproval": "Auto withdrawal",
	"disableLogout": "Disable logout",
	"isOffline": "Offline",
	"isTester": "Tester",
	"changePassword": "Change password",
	"currency": "Currency",
	"country": "Country",
	"registrationDate": "Registration date",
	"userRole": "Role",
	"description": "Description",
	"history": "History",
	"payoutAttemptHistory": "Payout attempt history (Payment system)",
	"state": "State",
	"expiredAt": "Expired at",
	"wager": "Wager",
	"wagerMaxBet": "Wager max bet",
	"wagerCounter": "Wager counter",
	"createdAt": "Created at",
	"event": "Event",
	"eventId": "Event ID",
	"vendor": "Vendor",
	"categories": "Categories",
	"tags": "Tags",
	"isVisible": "Visible",
	"isOn": "Is on",
	"hasDemo": "Demo",
	"isMobile": "Mobile",
	"gamesCount": "Number of games",
	"displayPosition": "Position",
	"add": "Add",
	"naming": "Naming",
	"login": "Login",
	"designStyle": "Style",
	"url": "URL",
	"image": "Image",
	"technology": "Technology",
	"hasLobby": "Has lobby",
	"provider": "Provider",
	"hasFreespins": "Freespins",
	"freespinFullDay": "Freespins full day",
	"hasTables": "Tables",
	"appeared": "Appeared",
	"disappeared": "Disappeared",
	"changed": "Changed",
	"processedAt": "Processed",
	"owner": "Owner",
	"currentUse": "Current use",
	"leftUse": "Left use",
	"unlimited": "Unlimited",
	"userId": "ID user",
	"ppId": "ID program",
	"eventType": "Event type",
	"isDelivered": "Delivered",
	"template": "Template",
	"isEnabled": "Enabled",
	"isDisabled": "Disabled",
	"isIframe": "Open in a frame",
	"formType": "Type",
	"updatedAt": "Updated at",
	"max": "Max",
	"min": "Min",
	"input": "Input",
	"output": "Output",
	"enabled": "Enabled",
	"disabled": "Disabled",
	"currencies": "Currencies",
	"deposit": "Deposit",
	"withdraw": "Withdraw",
	"withdrawal": "Withdrawal",
	"maxAmount": "Max amount",
	"minAmount": "Min amount",
	"feeFixed": "Fee fixed",
	"feePercentage": "Fee percentage",
	"requestId": "ID request",
	"user": "User",
	"admin": "Admin",
	"finishedAt": "Finished",
	"level": "Level",
	"percent": "Percent",
	"activationTimeout": "Activation timeout",
	"wageringTimeout": "Wagering timeout",
	"experience": "Experience",
	"supportLevel": "Support level",
	"personalManager": "Personal manager",
	"tournaments": "Tournaments",
	"weeklyBonuses": "Weekly bonuses",
	"personalBonuses": "Personal bonuses",
	"cashback": "Cashback",
	"cashbackPercent": "Cashback percent",
	"cashbackWager": "Cashback wager",
	"birthdayBonus": "Birthday bonus",
	"birthdayBonusAmount": "Birthday bonus amount",
	"coinCashout": "Coin cashout",
	"quickWithdrawal": "Quick withdrawal",
	"dailyWithdrawalLimit": "Daily withdrawal limit",
	"banDate": "Ban date",
	"action": "Action",
	"audience": "Audience",
	"timeFrom": "Time from",
	"timeTo": "Time to",
	"isLegacy": "Legacy",
	"duration": "Duration",
	"payoutStatus": "Payout status",
	"amountWrittenOff": "Amount to be written off",
	"amountCreated": "Amount to be credited",
	"card": "Card",
	"crypto": "Crypto",
	"address": "Address",
	"completedAt": "Completed",
	"balance": "Balance",
	"gameMetrics": "Game metrics",
	"ppName": "Partners program",
	"params": "Params",
	"errorMessage": "Error message",
	"code": "Code",
	"response": "Response",
	"rtp": "RTP",
	"minLine": "Min line",
	"maxLine": "Max line",
	"minBet": "Min bet",
	"maxBet": "Max bet",
	"maxBonus": "Max bonus",
	"minDeposit": "Min deposit",
	"volatility": "Volatility",
	"textColor": "Text color",
	"backgroundColor": "Background color",
	"statusSelected": "Nothing selected | {n} status selected | {n} statuses selected",
	"operationTypeSelected": "Nothing selected | {n} operation type selected | {n} operation types selected",
	"textDelete": "Are you sure you want to delete?",
	"newImageUsed": "If the image is changed, it will automatically appear in the table",
	"confirm": "Confirm",
	"reject": "Reject",
	"verified": "Verified",
	"pending": "Pending",
	"failed": "Failed",
	"rejected": "Rejected",
	"removed": "Removed",
	"returned": "Returned",
	"completed": "Completed",
	"new": "New",
	"pending_approval": "Pending approval",
	"pending_verification": "Pending verification",
	"pending_execution": "Pending execution",
	"approved": "Approved",
	"executed": "Executed",
	"canceled": "Canceled",
	"null": "Not specified",
	"chooseAll": "Choose all",
	"active": "Active",
	"activeBefore": "Active before",
	"link": "Link",
	"activationPeriod": "Activation period",
	"day": "Day",
	"hours": "Hours",
	"minute": "Minute",
	"average": "Average",
	"low": "Low",
	"medium": "Medium",
	"high": "High",
	"midLow": "Mid-low",
	"midHigh": "Mid-high",
	"fromMediumToHigh": "From medium to high",
	"fromLowToMedium": "From low to medium",
	"online": "Online",
	"vionetteIntegration": "Vionette integration",
	"topWinToday": "Top win today",
	"prizePool": "Prize pool",
	"withdrawalTime": "Withdrawal time",
	"tickerWidget": "Ticker widget",
	"real": "Real",
	"custom": "Custom",
	"show": "Show",
	"hide": "Hide",
	"pretitle": "Pretitle",
	"title": "Title",
	"subtitle": "Subtitle",
	"displayTheButton": "Display the button",
	"textOnButton": "Text on button",
	"linkForButton": "Link for button",
	"iconForButton": "Icon for button",
	"location": "Location",
	"visibleFor": "Visible for",
	"all": "All",
	"guests": "Guests",
	"players": "Players",
	"support_min": "Support min",
	"support_work_hours": "Support during work hours",
	"support_round_the_clock": "Support round the clock",
	"support_priority": "Support priority",
	"activate": "Activate",
	"manual": "Manual",
	"auto": "Auto",
	"bonusConfigHelp": "In the case of \"auto\", the bonus is issued without a wager",
	"levels": "Levels",
	"goals": "Goals",
	"goalConfigs": "Goal config",
	"rewards": "Rewards",
	"value": "Value",
	"target": "Target",
	"gamesType": "Games type",
	"executionTime": "Execution time",
	"type": "Type",
	"config": "Config",
	"isPeriodical": "Periodical",
	"depositDenominator": "Deposit denominator",
	"accruedAt": "Accrued",
	"activatedAt": "Activated",
	"canceledAt": "Canceled",
	"expired": "Expired",
	"halls": "Halls",
	"hall": "Hall",
	"cashier": "Cashier",
	"playersInGroup": "Players in group",
	"languages": "Languages",
	"dictionary": "Dictionary",
	"totalDebit": "Total debit",
	"totalCredit": "Total credit",
	"operations": "Operations per shift",
	"transactionId": "ID transaction",
	"from": "From",
	"to": "To",
	"operationsByAccount": "Operations by account",
	"openInFrame": "Open in frame",
	"authorizationCode": "Authorization code",
	"disableGamesAfterAdd": "Disable games after adding",
	"catalog": "Catalog",
	"currencyCatalog": "Currency catalog",
	"noCurrencies": "No currencies",
	"label": "Label",
	"transactionsBySessions": "Player's transactions within the game session",
	"transactionsByGame": "Player's transactions within the game",
	"transactionsByProvider": "Player's transactions within the provider",
	"payouts": "Payouts",
	"manager": "Manager",
	"locales": {
		"ru": "Russian",
		"en": "English"
	},
	"role": {
		"admin": "Admin",
		"sysop": "Sysop",
		"cashier": "Cashier",
		"support": "Support",
		"content-manager": "Content manager"
	},
	"placeholder": {
		"login": "Login",
		"password": "Password",
		"search": "Search",
		"nothingWasFound": "Nothing was found",
		"noData": "No data",
		"createNewTag": "Create new tag",
		"searchByProgramId": "Search by program Id",
		"inputPromoCode": "Input promo code",
		"inputTemplate": "Input template",
		"inputMessage": "Input message",
		"inputDescription": "Input description",
		"inputUsername": "Input username",
		"inputPassword": "Input password",
		"inputTarget": "Input target",
		"inputMinBet": "Input min bet",
		"inputMaxBet": "Input max bet",
		"inputGameType": "Input game type",
		"inputNaming": "Input naming",
		"inputURL": "Input URL",
		"inputPosition": "Input position",
		"inputType": "Input type",
		"inputValue": "Input value",
		"inputLogin": "Input login",
		"inputCode": "Input code",
		"inputCurrency": "Input currency",
		"inputLabel": "Input label",
		"confirmPassword": "Confirm password",
		"selectOperationType": "Select operation type",
		"selectPreset": "Select preset",
		"selectRole": "Select role",
		"selectCategories": "Select categories",
		"selectTags": "Select tags",
		"selectDate": "Select date",
		"selectCountry": "Select country",
		"selectCurrency": "Select currency",
		"selectPaymentSystem": "Select payment system",
		"selectFormType": "Select operation type",
		"selectRequisitesFormat": "Select requisites format",
		"selectVendor": "Select vendor",
		"selectProvider": "Select provider",
		"selectState": "Select state",
		"selectPayoutStatus": "Select payout status",
		"selectVolatility": "Select volatility",
		"selectStyle": "Select style",
		"selectEventType": "Select event type",
		"selectAudience": "Select audience",
		"selectTextCategory": "Select text category",
		"selectType": "Select type",
		"selectTimeStart": "Select time start",
		"selectTimeEnd": "Select time end",
		"selectCashier": "Select cashier",
		"selectSite": "Select site",
		"searchBy": "Search by {name}",
		"searchByUserId": "Search by user ID",
		"selectIntegration": "Select id integration",
		"searchByPaymentSystemId": "Search by payment system ID",
		"searchByAmount": "Search by amount",
		"searchByCurrency": "Search by currency",
		"searchBySessionId": "Search by session ID",
		"searchById": "Search by ID",
		"minAmount": "Min amount",
		"maxAmount": "Max amount",
		"selectAction": "Select action",
		"selectGroup": "Select group",
		"selectPromoCode": "Select promo code",
		"selectLanguage": "Select language"
	},
	"button": {
		"signIn": "Sign in",
		"add": "Add",
		"addTemplate": "Add template",
		"addBonus": "Add bonus",
		"logout": "Log out",
		"create": "Create",
		"back": "Back",
		"save": "Save",
		"delete": "Delete",
		"take": "Take",
		"resend": "Resend",
		"return": "Return",
		"deposit": "Deposit",
		"withdraw": "Withdraw",
		"withdrawal": "Withdrawal",
		"cancel": "Cancel",
		"apply": "Apply",
		"demo": "Demo",
		"default": "Default",
		"addOrRemove": "Add or remove",
		"update": "Update",
		"more": "More",
		"image": "Image",
		"addText": "Add text",
		"addPage": "Add page",
		"ban": "Ban",
		"copy": "Copy",
		"addGoal": "Add goal",
		"addGoalConfig": "Add goal config",
		"addConfig": "Add config",
		"addReward": "Add reward",
		"addPlayers": "Add players",
		"goToTranslating": "Go to translating",
		"goToPayments": "Go to payments",
		"deleteAll": "Delete all",
		"unban": "Unban",
		"statistics": "Statistics",
		"approve": "Approve",
		"reject": "Reject",
		"requestVerification": "Request verification",
		"change": "Change",
		"showIntegration": "Show integration",
		"connect": "Connect",
		"createReport": "Create report"
	},
	"error": {
		"required": "Required field",
		"withdrawalRequestFailed": "Withdrawal request failed, you can resend your request",
		"minimum": "Enter at least {number} characters",
		"passwordNotMatch": "Passwords don't match",
		"minMax": "The minimum value must not exceed the maximum",
		"maxMin": "The maximum value cannot be less than the minimum"
	},
	"eventTypes": {
		"register": "Registration",
		"registration": "Registration",
		"firstDeposit": "First deposit"
	},
	"invoiceHistory": {
		"new": "New",
		"pending_approval": "Pending approval",
		"pending_verification": "Pending verification",
		"pending_execution": "Pending execution",
		"approved": "Approved",
		"executed": "Executed",
		"rejected": "Rejected",
		"canceled": "Canceled",
		"pending": "Pending",
		"failed": "Failed",
		"returned": "Returned",
		"completed": "Completed"
	},
	"statusState": {
		"new": "New",
		"active": "Active",
		"canceled": "Canceled",
		"completed": "Completed",
		"expired": "Expired"
	},
	"modalTitle": {
		"createPlayer": "Create player",
		"createStaff": "Create staff",
		"createTag": "Create tag",
		"createReferralCode": "Create referral code",
		"createPaymentMethodWithdraw": "Create withdraw payment method",
		"createPaymentMethodDeposit": "Create deposit payment method",
		"addingCurrency": "Adding currency",
		"addingPaymentSystem": "Adding payment system",
		"createIntegration": "Create integration",
		"createMission": "Create mission",
		"createMissionLevel": "Create level for a mission",
		"createLevelGoal": "Create a goal for a level",
		"createGoalConfigs": "Create a configs for a goal",
		"createLevelReward": "Create a reward for a level",
		"createText": "Create text",
		"imagePreview": "Preview image",
		"cropImage": "Crop image",
		"delete": "Delete",
		"createPartnersProgram": "Create partners program",
		"createPartnersTemplate": "Create partners template",
		"createHall": "Create hall",
		"createLanguage": "Create language",
		"shiftReport": "Shift report",
		"statistics": "Statistics",
		"createMaintenance": "Create maintenance",
		"addingCurrencyInCatalog": "Adding currency in catalog",
		"addingWidget": "Adding widget",
		"addPromoCode": "Add promo code",
		"createReport": "Create report"
	},
	"hints": {
		"inputPromoCode": "Enter promo code (optional)",
		"minLength": "Minimum {number} characters",
		"maxLength": "Maximum {number} characters",
		"promoCodeUsed": "Specify how many times this code can be used",
		"uploadAllImage": "Preview will be available after uploading all pictures",
		"previewAvailable": "Preview available on desktop devices",
		"activeUntil": "Active until",
		"gameMetrics": "All values are numeric. The min bet can be a fractional number",
		"saveDictionaryTable": "Only values displayed on the page will be saved"
	},
	"toast": {
		"promoCodeDeleted": "Promo code deleted",
		"beginTimeError": "The start time must be greater than the current time",
		"serverError": "An error has occurred on the server. Please try again later",
		"incorrectCredential": "Incorrect login or password",
		"success": "Success",
		"rejected": "Rejected",
		"approved": "Approved",
		"verificationRequested": "Verification requested",
		"promoCodeCreated": "Promo code created",
		"promoCodeActive": "Promo code active",
		"promoCodeNotActive": "Promo code is not active",
		"categoryCreated": "Category created",
		"categoryDeleted": "Category deleted",
		"imageModified": "Image modified",
		"gameDeleted": "Game deleted",
		"mainPromoCreated": "New promo created",
		"mainPromoDeleted": "Promo remotely",
		"changesSaved": "Changes saved",
		"playerCreated": "Player created",
		"playerLoginError": "A player with this login has already been created",
		"ban": "Banned",
		"unban": "Unbanned",
		"integrationCreated": "Integration created",
		"integrationDeleted": "Integration is remote",
		"integrationUpdate": "Integration updated",
		"passwordChanged": "Password changed successfully",
		"staffCreated": "Staff created",
		"tagCreated": "Tag created",
		"tagDeleted": "Tag deleted",
		"textCopied": "Text copied successfully",
		"maxSizeHasBeenExceeded": "The maximum size has been exceeded",
		"invalidImageType": "Invalid image type",
		"newsCreated": "News created",
		"newsDeleted": "News deleted",
		"userBanned": "User banned",
		"userUnbanned": "User unbanned",
		"maintenanceCreated": "Maintenance successfully planned",
		"duplicateData": "Duplicate data",
		"levelDeleted": "Level deleted",
		"levelCreated": "Level created",
		"presetDeleted": "Preset deleted",
		"presetCreated": "Preset created",
		"cashbackConfigUpdate": "Cashback config updated",
		"referralConfigUpdate": "Referral config updated",
		"templateDeleted": "Template deleted",
		"templateCreated": "Template created",
		"bonusAccrue": "Bonus accrued",
		"missionCreated": "Mission created",
		"missionDeleted": "Mission deleted",
		"missionLevelCreated": "Mission level created",
		"missionLevelDeleted": "Mission level deleted",
		"goalConfigCreated": "Config goal created",
		"goalConfigDeleted": "Config goal deleted",
		"levelRewardCreated": "Level reward created",
		"levelRewardDeleted": "Level reward deleted",
		"withdrawalRequestSentAgain": "Withdrawal request sent again",
		"withdrawalRequestReturned": "Withdrawal request returned",
		"partnersProgramCreated": "Partners program created",
		"partnersProgramDeleted": "Partners program deleted",
		"partnersTemplateCreated": "Partners template created",
		"partnersTemplateDeleted": "Partners template deleted",
		"partnersPostbackRetry": "Partners postback retry",
		"playersGroupCreated": "Group players created",
		"playersGroupDeleted": "Group players deleted",
		"playerInAnotherGroup": "The player is already in another group",
		"paymentSystemAdded": "Payment system added",
		"paymentSystemDeleted": "Payment system deleted",
		"paymentSystemCannotBeDeleted": "Payment system cannot be deleted",
		"artifactCreated": "Artifact created",
		"artifactEmpty": "Artifact is empty",
		"withdrawMethodExist": "The withdraw method already exist",
		"depositMethodExist": "The deposit method already exist"
	},
	"sexUsers": {
		"male": "Male",
		"female": "Female"
	},
	"type_file": {
		"selfieAndId": "Selfie and ID",
		"confirmationId": "ID confirmation",
		"paymentMethod": "Payment method"
	},
	"styles": {
		"arcade": "Arcade",
		"board": "Board",
		"bonus-buy": "Bonus Buy",
		"casino": "Casino",
		"favorites": "Favorites",
		"high-volatility": "High Volatility",
		"hit": "Hit",
		"instant": "Instant",
		"jackpot": "Jackpot",
		"keno": "Keno",
		"low-volatility": "Low Volatility",
		"megaways": "Megaways",
		"mystery": "Mystery",
		"new": "New",
		"popular": "Popular",
		"seasonal-games": "Seasonal Games",
		"slots": "Slots",
		"top-winners": "Top Winners",
		"trending": "Trending"
	},
	"actor": "Actor",
	"bet": "Bet",
	"bonus_accrue": "Bonus accrued",
	"bonus_revoke": "Bonus revoked",
	"refund": "Refund",
	"win": "Win",
	"onlyCompleted": "Only completed",
	"paymentSystemId": "ID PS",
	"rate": "Rate",
	"targetCurrency": "Target currency",
	"currencyPair": "Currency pair",
	"transactionsByIntegrations": "Transactions by integrations",
	"sessionId": "Session ID",
	"providerGameId": "Provider ID",
	"roundId": "Round ID",
	"isEmailVerified": "Email verified",
	"userPasswordHasBeenReset": "The user's password has been reset",
	"promoCodesForHalls": "Promo codes for halls",
	"groupId": "Group ID",
	"youNeedToSpecifyAnExistingCode": "You need to specify an existing referral promo code",
	"listReports": "List reports",
	"report": "Report",
	"reportPlayers": "Players",
	"reportTotals": "Totals",
	"totalDepositsByCashier": "Total deposits by cashier",
	"totalWithdrawalsByCashier": "Total withdrawals by cashier",
	"loss": "Loss"
}
